import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import Validator from "validator";
import { getStates } from "../../modules/utils";
import isEmpty from "lodash/isEmpty";

function validateInput(data) {
  let errors = {};
  if (!data.firstname || Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }
  if (!data.lastname || Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }
  if (!data.address1 || Validator.isEmpty(data.address1)) {
    errors.address1 = "This field is required";
  }
  if (!data.city || Validator.isEmpty(data.city)) {
    errors.city = "This field is required";
  }
  if (!data.state || Validator.isEmpty(data.state)) {
    errors.state = "This field is required";
  }
  if (!data.country || Validator.isEmpty(data.country)) {
    errors.country = "This field is required";
  }
  if (!data.zipcode || Validator.isEmpty(data.zipcode)) {
    errors.zipcode = "This field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class BillingAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  defaultState = () => {
    return {
      firstname: "",
      lastname: "",
      address1: "",
      address2: "",
      country: "US",
      city: "",
      state: "",
      zipcode: "",
      errors: {},
      isLoading: false,
      isShippingChecked: false
    };
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.cart.cart.billing) {
      this.setState({
        ...this.state,
        ...nextProps.cart.cart.billing,
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname
      });
    }else{
      this.setState({
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname
      })
    }
  }

  _onChange = event => {
    console.log(event);
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }
  handleBilling = event => {
    event.preventDefault();
    const {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;

    const billing = {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    };
    //check if user selects billing same as shipping
    if (this.state.isShippingChecked) {
      delete this.props.auth.profile.userShipping._id;
      this.props.handleBilling(this.props.auth.profile.userShipping);
    }

    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.handleBilling(billing);
    }
  };

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  toggleChange = () => {
    delete this.props.auth.profile.userShipping._id;
    this.props.handleBilling(this.props.auth.profile.userShipping);
  };

  render() {
    const {
      errors,
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;
    return (
        <div className="col-md-8 services_clip">
          <div className="">
            <div className="row">
              <div className="col-lg-12">
                <div className="services_boxes">
                  <div className="services_content">
                    <h2 className="mb-0">Billing Address</h2>
                    <div style={{ clear: "both", height: "15px" }} />
                    <p className="mb-0">
                      <input
                          id="SameAddress"
                          type="radio"
                          checked={this.state.isShippingChecked}
                          onChange={this.toggleChange}
                      />{" "}
                      <label for="SameAddress">Same as Shipping Address</label>
                    </p>
                    <div style={{ clear: "both", height: "15px" }} />
                    <div className="row">
                      <div className="col-lg-6">
                          <TextFieldGroup
                              field="firstname"
                              value={firstname}
                              error={errors.firstname}
                              onChange={this._onChange}
                              placeholder="First Name"
                              error={errors.firstname}
                          />
                      </div>
                      <div className="col-lg-6">
                          <TextFieldGroup
                              field="lastname"
                              value={lastname}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Last Name"
                              error={errors.lastname}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="address1"
                              value={address1}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 1"
                              error={errors.address1}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="address2"
                              value={address2}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 2"
                              error={errors.address2}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="city"
                              value={city}
                              error={errors.city}
                              onChange={this._onChange}
                              placeholder="City"
                              error={errors.city}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <select
                            name="state"
                            onChange={this._onChange}
                            className="state form-control"
                            value={state}
                        >
                          <option value="">State</option>;
                          {getStates().map(function(state, index) {
                            return (
                                <option key={index} value={state.abbreviation}>
                                  {state.name}
                                </option>
                            );
                          })}
                        </select>

                        {errors.state && (
                            <span className="error-color">{errors.state}</span>
                        )}
                      </div>
                    </div>
                      <div className="row">
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="zipcode"
                            value={zipcode}
                            error={errors.zipcode}
                            onChange={this._onChange}
                            placeholder="ZIP code"
                            error={errors.zipcode}
                        />
                      </div>
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="country"
                            value={country}
                            error={errors.country}
                            onChange={this._onChange}
                            placeholder="Country"
                            error={errors.country}
                            disabled
                        />
                      </div>
                    </div>

                    <div style={{ clear: "both", height: "40px" }} />

                    <div className="row">
                    <div className="col-lg-12">
                    <a
                        href="javascript:void(0)"
                        onClick={this.goBack}
                        className="btn btn-white mr-15"
                    >
                      Back
                    </a>
                    <a
                        href="javascript:void(0)"
                        onClick={this.handleBilling}
                        className="btn btn-orange"
                    >
                      CONTINUE
                    </a>
                    </div>
                    </div>
                    <div style={{ clear: "both", height: "100px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    cart: state.cart
  };
}

export default connect(mapStateToProps)(BillingAddress);



// WEBPACK FOOTER //
// ./src/pages/checkout/BillingAddress.js